import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  public isDesktop(): boolean {
    //window.innerWidth > 768
    return true
  }
}
